import { tracking } from '@iwoca/frontend-tracking-library';
import {
  IconChatFilled,
  IconEmailFilled,
  IconPhoneFilled,
  IconQuestionMarkFilled,
} from '@iwoca/icons';
import { Trans } from '@lingui/react/macro';

import styles from './Help.module.css';
import { useLocale } from '../../../hooks/useLocale';
import { getAmplitudeDefaultEventProperties } from '../../../utils/amplitudeEvents';
import { useCanBootIntercom } from '../../Intercom/useCanBootIntercom';

type THelpType = 'FAQ' | 'phone' | 'email' | 'chat';

const HelpContents = () => {
  const { isDE } = useLocale();
  const isChatEnabled = useCanBootIntercom();

  const handleTrackClickHelpLink = (helpType: THelpType) => {
    tracking.ampli.helpMethodSelected({
      CTA_type: helpType,
      ...getAmplitudeDefaultEventProperties(),
    });
  };

  const supportNumber = isDE ? '06994323020' : '02037780105';
  const supportEmail = isDE ? 'support@iwoca.de' : 'support@iwoca.co.uk';

  return (
    <div className={styles.helpItems}>
      <div className={styles.helpGroup}>
        <p className={styles.groupLabel}>
          <Trans>Monday to Friday (9am - 6pm)</Trans>
        </p>

        {isChatEnabled && (
          <div className={styles.helpItem}>
            <IconChatFilled
              data-testid="chatFilled-icon"
              width={20}
              height={20}
              className={styles.helpItemIcon}
            />
            <div>
              <Trans>
                <button
                  type="button"
                  className={`ChatSupportButton ${styles.helpItemButton}`}
                  onClick={() => handleTrackClickHelpLink('chat')}
                >
                  Chat to us
                </button>{' '}
                for a quick reply
              </Trans>
            </div>
          </div>
        )}

        <div className={styles.helpItem}>
          <IconPhoneFilled
            data-testid="phoneFilled-icon"
            width={20}
            height={20}
            className={styles.helpItemIcon}
          />
          <div>
            <Trans>
              Call us on{' '}
              <a
                href={`tel:${supportNumber}`}
                target="_blank"
                rel="noreferrer"
                onClick={() => handleTrackClickHelpLink('phone')}
              >
                020 3778 0105
              </a>
            </Trans>
          </div>
        </div>

        <div className={styles.helpItem}>
          <IconEmailFilled
            data-testid="emailFilled-icon"
            width={20}
            height={20}
            className={styles.helpItemIcon}
          />
          <div>
            <Trans>
              Email us at{' '}
              <a
                href={`mailto:${supportEmail}`}
                target="_blank"
                rel="noreferrer"
                onClick={() => handleTrackClickHelpLink('email')}
              >
                support@iwoca.co.uk
              </a>
            </Trans>
          </div>
        </div>
      </div>

      <div className={styles.helpGroup}>
        <div className={styles.helpItem}>
          <IconQuestionMarkFilled
            data-testid="questionMarkFilled-icon"
            width={20}
            height={20}
            className={styles.helpItemIcon}
          />
          <div>
            <Trans>
              Find answers in our{' '}
              <a
                href="/faq/"
                target="_blank"
                rel="noreferrer"
                onClick={() => handleTrackClickHelpLink('FAQ')}
              >
                FAQ
              </a>
            </Trans>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpContents;
